import {createSelector} from "@reduxjs/toolkit";

import {CommonState} from "..";
import {combine} from "../../utils";
import {InitialState} from "./types";
import {IOrganisation, IOrganisationUser} from "../../common/organisation";
import {IGroup} from "../../common/group";

export const selectOrganisationReducer = (state: CommonState): InitialState => state.organisation;
export const selectOrganisationByAlias = (state: CommonState, alias: IOrganisation['alias']) => combine(
    selectOrganisationReducer,
    (organisationState: InitialState) => organisationState[alias]
)(state);

const userSortFn = (a: IOrganisationUser, b: IOrganisationUser) => {
    if (a.name >  b.name) {
        return 1;
    } else {
        return -1;
    }
}
export const selectOrganisationUsers = createSelector([
    (state: CommonState, alias: IOrganisation['alias']) => selectOrganisationByAlias(state, alias),
], (
    organisation,
) => {
    if (!organisation?.users?.length) {
        return [];
    }
    const result = [...organisation.users];
    result.sort(userSortFn);
    return result;
});

export const selectOrganisationUsersInGroup = createSelector(
    [
        (state: CommonState, {alias}: {alias: IOrganisation['alias']}) => selectOrganisationUsers(state, alias),
        (state: CommonState, {groupId} : {groupId: IGroup['id']}) => groupId,
    ], (users, groupId) => {
        const usersInGroup =  users?.filter((user: IOrganisationUser) => user.groups.findIndex(group => group.id === groupId) !== -1);
        if (!usersInGroup.length) {
            return usersInGroup;
        }
        const result = [...usersInGroup]; 
        result.sort(userSortFn);
        return result;
    },
);

export const selectOrganisationUsersOutsideOfGroup = createSelector(
    [
        (state: CommonState, {alias}: {alias: IOrganisation['alias']}) => selectOrganisationUsers(state, alias),
        (state: CommonState, {groupId} : {groupId: IGroup['id']}) => groupId,
    ], (users, groupId) => users.filter((user: IOrganisationUser) => user.groups.findIndex(group => group.id === groupId) === -1),
);